<template lang="pug">
div
  .text-editor
    .button-container
      div.d-flex.align-center.justify-end.fill-height
        y-button(:label="uploadedFileCount ? $tc('files', uploadedFileCount) : 'Upload file'" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-attachment-01" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAddEditFileDialog = true")
        y-button.ml-3(outlined color="neutral400" prepend-icon="$yzi-maximize-01" icon-color="neutral700" icon-size="17" unset-min-width size="xxs" height="24" button-class="px-1" @click="showConsultationNoteDialog = true")
    froala(id="edit" :tag="'textarea'" :config="config" v-model="form" ref="editor")
    div
      v-divider
      div.d-flex.align-center.justify-end.px-3.py-1
        y-button(:label="$t('attach_photo')" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-upload-03" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAttachDialog = true")
        y-button.ml-3(:label="$t('save')" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-save-01" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" :loading="isLoading" @click="$emit('onSave')")

  .dialogs
    attach-photo-dialog(v-if="showAttachDialog" :open.sync="showAttachDialog" @onUpload="onUploadPhoto")
    add-edit-file-dialog(v-if="showAddEditFileDialog" :open.sync="showAddEditFileDialog" :pid="leadPid" @onUpdateCount="updateFileCount")
    consultation-note-dialog(v-if="showConsultationNoteDialog" :open.sync="showConsultationNoteDialog" @save="$emit('onSave')")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'})

import AttachPhotoDialog from '@/components/clinic/dialogs/AttachPhotoDialog.vue'
import AddEditFileDialog from '@/components/clinic/dialogs/AddEditFileDialog.vue'
import ConsultationNoteDialog from '@/components/clinic/consultation/ConsultationNoteDialog.vue'
 
export default {
  name: 'TextEditor',
  props: ['isLoading', 'height'],
  components: { AttachPhotoDialog, AddEditFileDialog, ConsultationNoteDialog },
  data () {
    return {
      showAttachDialog: false,
      showAddEditFileDialog: false,
      showConsultationNoteDialog: false,
      config: {
        events: {
          'image.beforeUpload' () {
            return false
          },
          // 'blur': () => {
          //   this.$emit('onSave')
          // }
        },
        key: process.env.VUE_APP_FROALA_API_KEY,
        attribution: false,
        scrollableContainer: '#edit',
        codeBeautifierOptions: {
          indent_inner_html: false,
          indent_size: 4
        },
        toolbarBottom: false,
        toolbarButtons: {
          'moreText': {
            buttons: ['bold', 'italic', 'underline', 'formatUL', 'undo', 'redo'],
            'buttonsVisible': 7
          }
        },
        quickInsertEnabled: false,
        imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
        imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
        imageResizeWithPercent: true,
        fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
        paragraphFormat: {
          N: 'Normal',
          H1: 'Heading 1',
          H2: 'Heading 2',
          H3: 'Heading 3',
          H4: 'Heading 4',
        },
        toolbarSticky: false,
        heightMin: this.height,
        charCounterCount: false,
        enter: FroalaEditor.ENTER_BR
      },
    }
  },
  mounted () {},
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      leadPid: 'treatment/getLeadPid',
    }),
    form: {
      get () {
        return this.consultation.note
      },
      set (newValue) {
        this.$store.commit('treatment/updateConsultation', { note: newValue })
      }
    },
    uploadedFileCount () {
      return this.consultation.attachments.length
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    onUploadPhoto (photos) {
      photos.reverse()
      for (const i in photos) {
        const photo = photos[i]
        this.insertPhoto(photo)
      }
    },
    insertPhoto (photo) {
      const editor = this.$refs?.editor?.$el['data-froala.editor']
      if (editor) {
        let photoUrl = photo.file
        photoUrl = photoUrl.replace('https://cdn.yezza.io', 'https://img.yezza.io/full-fit-in')
        editor.image.insert(photoUrl, null, { 'name': photo.filename, 'id': photo.hid }, null, null)
      }
    },
    updateFileCount (items) {
      let files = items.map(m => m.id)
      this.$store.commit('treatment/updateConsultation', { attachments: files })
    },
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  .fr-box.fr-basic .fr-wrapper {
    border: none !important;
  }
  .fr-toolbar {
    border: none !important;
    .fr-command.fr-btn {
      margin: 0px 2px;
    }
  }
  .fr-box .fr-counter {
    visibility: hidden !important;
  }
   p {
    margin-bottom: 0px !important;
  }
  ul, ol {
    padding-left: 0px;
  }
  li {
    font-family: $body-font-family;
    font-size: 16px !important;
    line-height: 24px !important;
    line-height: 24px !important;
  }
  .fr-box.fr-basic .fr-element.fr-view {
    font-family: $body-font-family;
    font-size: 16px !important;
    line-height: 24px !important;
    line-height: 24px !important;
    color: #333333;
  }
  .fr-second-toolbar {
    border: unset
  }
  .fr-box.fr-basic .fr-element.fr-view {
    font-size: 14px !important;
  }
  .fr-dropdown-menu {
    left: unset !important;
    bottom: unset !important;
    margin-left: unset !important;
  }
}
.text-editor {
  position: relative;
}
.button-container {
  position: absolute;
  height: 41px;
  left: 0;
  top: 0;
  margin-left: 330px;
  width: -webkit-fill-available;
  padding-right: 12px;
  z-index: 1;
}
</style>

<i18n>
{
  "en": {
    "files" : "1 file in this case notes | {n} files in this case notes"
  }
}
</i18n>